export class ServicesConfig {

    constructor(
        readonly aim: AimConfig
    ) { }
}

export class AimConfig {

    constructor(
        readonly url: string,
        readonly appToken: string
    ) { }

}
